import { render, staticRenderFns } from "./ListUnitOfMeasurePage.vue?vue&type=template&id=f9231a50"
import script from "./ListUnitOfMeasurePage.vue?vue&type=script&lang=js"
export * from "./ListUnitOfMeasurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports